(() => {
  const button = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#MainNavigation');
  if (!button || !nav) return;
  button.hidden = false;
  const close = () => {
    button.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
  };
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    nav.classList.toggle('is-open', open);
  });
  nav.addEventListener('click', event => {
    if (event.target.closest('a')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      close();
      button.focus();
    }
  });
  document.addEventListener('click', event => {
    if (!nav.contains(event.target) && !button.contains(event.target)) close();
  });
})();

(() => {
  const initialized = new WeakSet();
  const initScenes = () => {
    document.querySelectorAll('.scene-controls').forEach(controls => {
      if (initialized.has(controls)) return;
      const choices = [...controls.querySelectorAll('[data-scene]')];
      const stage = document.getElementById(choices[0]?.getAttribute('aria-controls'));
      if (!stage || !choices.length) return;
      const scenes = [...stage.querySelectorAll('.hero-scene')];
      if (choices.some(choice => !scenes.some(scene => scene.id === choice.dataset.scene))) return;
      choices.forEach(choice => {
        choice.addEventListener('click', () => {
          choices.forEach(item => item.setAttribute('aria-pressed', String(item === choice)));
          scenes.forEach(scene => {
            const active = scene.id === choice.dataset.scene;
            scene.classList.toggle('is-active', active);
            scene.setAttribute('aria-hidden', String(!active));
          });
        });
      });
      controls.hidden = false;
      initialized.add(controls);
    });
  };
  initScenes();
  document.addEventListener('shopify:section:load', initScenes);
})();

(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window)) return;
  const observed = new WeakSet();
  const observer = new window.IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
  const reveal = () => {
    if (motion.matches) return;
    document.querySelectorAll('.section-heading, .blend-card, .story-art, .story-copy, .process-grid li, .faq, .newsletter-grid').forEach(element => {
      if (observed.has(element) || element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('reveal-pending');
      observed.add(element);
      observer.observe(element);
    });
  };
  const showAll = () => {
    if (!motion.matches) return;
    observer.disconnect();
    document.querySelectorAll('.reveal-pending').forEach(element => element.classList.add('is-visible'));
  };
  motion.addEventListener('change', showAll);
  document.addEventListener('focusin', event => {
    event.target.closest('.reveal-pending')?.classList.add('is-visible');
  });
  document.addEventListener('shopify:section:load', reveal);
  reveal();
})();
